module.exports = __webpack_public_path__ + "static/img/partner-logo-4.1db609a0.png";